import React from 'react';

interface Props {
  label: string;
  majorityResult: number;
}
const PollTeaserResult = ({ label, majorityResult }: Props) => {
  return (
    <div className="pollteaser__result">
      <div className="pollteaser__result-label">{label}</div>
      <div className="pollteaser__result-relative">{majorityResult.toFixed(2)} %</div>
    </div>
  );
};

export default PollTeaserResult;
